module Bookhus {
    export class DealsDataservice implements IDealsDataService {
        loadDataAjax(pagenumber: number, dealType: number): JQueryXHR {

            var typestring: string;
            switch (dealType) {
                case 0:
                    typestring = "Deal";
                    break;
                case 1:
                    typestring = "Cancellation";
                    break;
                case 2:
                    typestring = "Highlighted";
                    break;
                case 3:
                    typestring = "Random";
                    break;
                default:
                    break;
            }

            var self = this;
            var xhr = $.getJSON('/api/deals?pagenumber=' + pagenumber + '&type=' + typestring, function (deal) {
                self.deal = deal;
            });

            return xhr;
        }

        deal: IDeal;
    }
}